import { render, staticRenderFns } from "./WarehouseChildren.vue?vue&type=template&id=470b2420"
import script from "./WarehouseChildren.vue?vue&type=script&lang=js"
export * from "./WarehouseChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports